export default {
  contracts: {
    results: [],
  },
  single_contract: {
    document: {
      clauses: [],
    },
    brand: {
      account: {},
    },
    customer: {},
  },
  contract_history: [],
  contract_templates: {
    results: [],
  },
  contract_templates_file: {
    results: [],
  },
  single_contract_template: {
    content: {
      clauses: [],
    },
  },
  single_contract_template_file: {
    contract: ''
  },
  contract_template_fields: [],
  contractList: {},
  contractListCount: 0,
}